import { useState } from 'react';
import { useIsMobile } from '@/hooks/use-mobile';

interface UseDialogStateProps {
  isMobile?: boolean;
}

export const useDialogState = (props?: UseDialogStateProps) => {
  const isMobileDetected = useIsMobile();
  const isMobile = props?.isMobile !== undefined ? props.isMobile : isMobileDetected;
  const [searchDialogOpen, setSearchDialogOpen] = useState<boolean>(false);
  const [isFullScreen, setIsFullScreen] = useState<boolean>(false);

  const handleSearchClick = (fetchInitialResults?: () => void) => {
    if (isMobile) {
      setIsFullScreen(true);
    }
    setSearchDialogOpen(true);

    if (fetchInitialResults) {
      fetchInitialResults();
    }
  };

  const toggleFullScreen = () => {
    setIsFullScreen(prevState => !prevState);
  };

  const closeDialog = () => {
    setSearchDialogOpen(false);
  };

  return {
    searchDialogOpen,
    setSearchDialogOpen,
    isFullScreen,
    setIsFullScreen,
    handleSearchClick,
    toggleFullScreen,
    closeDialog
  };
};
